import Box from '@material-ui/core/Box';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ReactNode, forwardRef } from 'react';

import colors from '../../themes/main-colors';
import { Grid, Hidden } from '@material-ui/core';
import { useTranslation } from '../../hooks/useTranslation';
import { InputType } from '../../pages/auth/forgot-password';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    details: {
      justify: 'center',
    },
    summaryContent: {
      '& .MuiExpansionPanelSummary-content.Mui-expanded': {
        margin: 0,
      },
    },
    label: {
      color: colors.noirBlur,
      fontSize: '16px',
      fontWeight: 400,
    },
    alternateLabelStyle: {
      color: colors.sparkBlue,
      fontWeight: 700,
    },
    root: {
      padding: '0px 8px',
    },
  }),
);

export interface PGEExpansionPanelProps {
  title: string | ReactNode;
  content?: any | null;
  children?: JSX.Element;
  style?: any;
  isAlternatePanelStyle?: boolean;
  defaultExpand?: boolean;
  onChange?: (panel: InputType) => void;
  name?: InputType;
  labelStyle?: any;
}

const PGEExpansionPanel = forwardRef<HTMLElement, PGEExpansionPanelProps>(
  (props, ref) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const handleChange = () => {
      props.onChange ? props.onChange(props.name!) : undefined;
    };
    return (
      <ExpansionPanel
        onChange={handleChange}
        style={
          props.isAlternatePanelStyle
            ? { boxShadow: 'none', margin: 0 }
            : undefined
        }
        className={
          props.isAlternatePanelStyle ? classes.summaryContent : undefined
        }
        defaultExpanded={props?.defaultExpand}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon color={'primary'} />}
          className={classes.details}
          style={{ margin: 0 }}
        >
          {!props.isAlternatePanelStyle ? (
            <Box justifyContent={'center'}>
              <Typography
                variant={'button'}
                style={props.labelStyle}
                className={classes.label}
              >
                {props.title}
              </Typography>
            </Box>
          ) : (
            <>
              <Grid container justify={'space-between'}>
                <Grid item> {props.title}</Grid>
                <Hidden smDown>
                  <Grid
                    item
                    className={classes.alternateLabelStyle}
                    style={{ margin: '1em 0' }}
                  >
                    {t('SHOW_MORE')}
                  </Grid>
                </Hidden>
              </Grid>
            </>
          )}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.root} style={props.style}>
          {props.content || props.children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  },
);

export default PGEExpansionPanel;
